module.exports = __webpack_public_path__ + "static/media/isNotActiveButton.01bc1f6c.svg";